import React from "react";

export const ChatBlack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.478"
      height="29.478"
      viewBox="0 0 29.478 29.478"
    >
      <g id="chat" transform="translate(-0.005 0)">
        <g
          id="Group_12188"
          data-name="Group 12188"
          transform="translate(0.005 0)"
        >
          <path
            id="Path_225486"
            data-name="Path 225486"
            d="M3.4,22.991A5.733,5.733,0,0,1,.585,22.25.888.888,0,0,1,.23,21.006a6.245,6.245,0,0,0,.8-4.8A19.3,19.3,0,0,1,0,11.286,11.364,11.364,0,0,1,11.557,0,11.423,11.423,0,0,1,22.645,11.314,11.416,11.416,0,0,1,6.976,21.764,5.814,5.814,0,0,1,3.4,22.991Zm-1.2-1.939a4.06,4.06,0,0,0,4.008-.945.875.875,0,0,1,.986-.16,9.633,9.633,0,0,0,13.693-8.633,9.569,9.569,0,0,0-19.138-.023c0,1.706.661,3.069,1.025,4.684a7.814,7.814,0,0,1-.574,5.078Z"
            transform="translate(-0.005 0)"
            fill="#414851"
          />
        </g>
        <g
          id="Group_12189"
          data-name="Group 12189"
          transform="translate(10.449 10.198)"
        >
          <path
            id="Path_225487"
            data-name="Path 225487"
            d="M158.781,159.05a5.814,5.814,0,0,1-3.572-1.227,11.448,11.448,0,0,1-11.759-1.879.876.876,0,1,1,1.145-1.325,9.682,9.682,0,0,0,10.389,1.387.875.875,0,0,1,.986.16,4.06,4.06,0,0,0,4.008.945,7.781,7.781,0,0,1-.324-5.956c.006-.018.013-.035.02-.053a9.667,9.667,0,0,0-1.454-9.9.876.876,0,1,1,1.344-1.123,11.374,11.374,0,0,1,2.616,7.261,11.241,11.241,0,0,1-.882,4.414,6.177,6.177,0,0,0,.657,5.305.888.888,0,0,1-.355,1.244,5.736,5.736,0,0,1-2.819.741Z"
            transform="translate(-143.147 -139.77)"
            fill="#414851"
          />
        </g>
        <g
          id="Group_12193"
          data-name="Group 12193"
          transform="translate(4.835 9.973)"
        >
          <g
            id="Group_12190"
            data-name="Group 12190"
            transform="translate(5.104)"
          >
            <ellipse
              id="Ellipse_132"
              data-name="Ellipse 132"
              cx="1.385"
              cy="1.385"
              rx="1.385"
              ry="1.385"
              fill="#414851"
            />
          </g>
          <g id="Group_12191" data-name="Group 12191">
            <ellipse
              id="Ellipse_133"
              data-name="Ellipse 133"
              cx="1.385"
              cy="1.385"
              rx="1.385"
              ry="1.385"
              fill="#414851"
            />
          </g>
          <g
            id="Group_12192"
            data-name="Group 12192"
            transform="translate(10.209)"
          >
            <ellipse
              id="Ellipse_134"
              data-name="Ellipse 134"
              cx="1.385"
              cy="1.385"
              rx="1.385"
              ry="1.385"
              fill="#414851"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
